import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';

const baseStyles = {
    placeholderIcon: { width: 25, height: 25, marginTop: 32 },
    menuIcon: { width: 30, height: 30, margin: 20, marginStart: 18 },
    searchIcon: { width: 29, height: 29, margin: 20, marginEnd: Device.isWeb ? 0 : 13 },
    backIcon: { width: 29, height: 29, marginStart: Device.isWeb ? 0 : 11 },
    filterIcon: { width: 25, height: 25 },
    backIconWithTextView: {
        flexDirection: 'row'
        // flex: 1,
        // alignItems: 'center',
        // justifyContent: 'center'
    },
    backIconWithTextText: {
        color: Theme.primaryTextColor,
        alignSelf: 'center',
        fontSize: Device.isWeb ? 21 : 18,
        fontFamily: Theme.regularFont
    }
};

export default StyleSheet.create(baseStyles);
